import useIntercom from '@/hooks/use-intercom.hook';
import Button, { ButtonProps } from '../../button';
import { FC } from 'react';
import FlatButton from '@/components/flat-button';

const IntercomArticles = {
  'public-services': 11408977,
  'intent-topics': 13613222,
  'license-classification': 13063022,
  'model-gateway': 13974396,
  'custom-entity-regex': 16529807,
} satisfies Record<string, number>;

type IntercomArticle = keyof typeof IntercomArticles;

interface Props extends ButtonProps {
  intercomArticle: IntercomArticle;
  flatButton?: boolean;
  label?: string;
}

const IntercomButton: FC<Props> = ({
  intercomArticle,
  flatButton = false,
  label = 'Learn More',
  ...buttonProps
}) => {
  const { showArticle } = useIntercom();
  const articleId = IntercomArticles[intercomArticle];
  return flatButton ? (
    <FlatButton
      label={label}
      icon="documentation"
      onClick={() => showArticle(articleId)}
      size="small"
      color="link"
      dotdot={false}
    />
  ) : (
    <Button
      onClick={() => {
        showArticle(articleId);
      }}
      label={label}
      icon="documentation"
      {...buttonProps}
    />
  );
};
export default IntercomButton;
